import { Box, Pagination, Stack } from "@mui/material";
import CustomerTable, { CustomerTableWithPagination } from "./customerTable";
import { useState } from "react";
import CustomerSearchForm from "./dialog/searchCustomer/customerSearchForm";
import { CustomerService } from "../../service/customerService";
import { toast } from "react-toastify";
import { isLocalDev } from "../../utils/environment";
import useEffectOnUpdates from "../../hooks/useEffectOnUpdates";
import { UI_ACTION_TYPE, useUIContext } from "../../state/ui";
import { initialPageSize, withPagination } from "../hoc/withPagination";

const pageSize = 20;

export default function SearchCustomer({ onDone, filterCustomer }) {

    const [pagination, setPagination] = useState({
        count: 0,
        from: 0,
        to: pageSize
    });
    const [customers, setCustomers] = useState([]);
    const [searchParam, setSearchParam] = useState(null);
    const [totalCount, setTotalCount] = useState(0);
    const [currentPageTotal, setCurrentPageTotal] = useState(0);

    const { dispatch } = useUIContext();

    const handleCustomerSelect = (customer) => {
        onDone(customer);
    };

    useEffectOnUpdates(() => {
        if(searchParam.firstname || searchParam.lastname || searchParam.phone)
            doSearch()
    }, [searchParam]);

    const handleSearchDone = async (searchParam) => {
        setSearchParam({ ...searchParam, offset: 0, limit: initialPageSize });
    }

    const doSearch = async () => {
        dispatch({
            loading: true,
            type: UI_ACTION_TYPE.LOADING,
            loadingtext: "Searching...Please wait",
        });
        try {

            const customerSearchResult = await CustomerService.search(searchParam);
            const { code, message, data } = { ...customerSearchResult };
            
            //dispatch({ loading: false, type: UI_ACTION_TYPE.LOADING });
            if (code === 0) {
                let customerRows = data.rows;
                // if (filterCustomer) {
                //     customerRows = customerRows.filter(p => p.familyGroupId !== filterCustomer.familyGroupId)
                // }
                setCustomers(customerRows);
                setTotalCount(data.count);
                setCurrentPageTotal(customerRows.length);
                //setPagination({ ...pagination, count: data.count });
            } else {
                setCustomers([]);
                setTotalCount(0);
                setCurrentPageTotal(0);
                toast.info(message);
            }
        } catch (error) {
            //dispatch({ loading: false, type: UI_ACTION_TYPE.LOADING });
            if (isLocalDev) {
                console.log(error);
            }
        }
    }

    const handlePageChange = (from, to) => {
        setSearchParam({ ...searchParam, offset: from, limit: to });
    }

    return (
        <Stack>

            <CustomerSearchForm onSearchDone={handleSearchDone} />
            <CustomerTableWithPagination
                onPageChange={handlePageChange}
                currentPageTotal={currentPageTotal}
                totalCount={totalCount}
                customers={customers}
                onSelect={handleCustomerSelect} />

        </Stack>
    );
}


// {withPagination(<CustomerTable customers={customers} onSelect={handleCustomerSelect} onPageChange={handlePageChange} />,
// handlePageChange, currentPageTotal, totalCount)}